'use client';

import { useEffect, useRef } from 'react';

interface BackgroundVideoProps {
  src: string;
  fallbackSrc?: string;
  className?: string;
}

export function BackgroundVideo({ 
  src, 
  fallbackSrc = "https://pub-33ea9fef23824733bfd34c2ea86136dc.r2.dev/hero.mp4",
  className = "absolute top-0 left-0 w-full h-full object-cover z-0"
}: BackgroundVideoProps) {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      console.log('Video element created, attempting to load:', src);
      
      const handleCanPlay = () => {
        console.log('Video can play, attempting autoplay');
        video.play().catch(err => {
          console.error('Autoplay failed:', err);
        });
      };

      const handleError = (e: Event) => {
        console.error('Video error:', e);
        if (video.src !== fallbackSrc && !video.src.includes('pub-33ea9fef23824733bfd34c2ea86136dc.r2.dev')) {
          console.log('Switching to fallback video:', fallbackSrc);
          video.src = fallbackSrc;
          video.load();
        }
      };

      video.addEventListener('canplay', handleCanPlay);
      video.addEventListener('error', handleError);
      video.addEventListener('loadstart', () => console.log('Video load started'));

      return () => {
        video.removeEventListener('canplay', handleCanPlay);
        video.removeEventListener('error', handleError);
      };
    }
  }, [src, fallbackSrc]);

  return (
    <video
      ref={videoRef}
      autoPlay
      muted
      loop
      playsInline
      preload="auto"
      className={className}
      style={{ objectFit: 'cover' }}
    >
      <source src={src} type="video/mp4" />
      <source src={fallbackSrc} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  );
} 